export default "../css/c04fa747763b35d441b965274e437c31.ttf";